//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let token = localStorage.getItem("token-admin")
export default {
  name: "NewDIP",
  data: function() {
    return {
      id: '',
      newInfo: { description: "", legalBase: "", timeCreated: 0, },
      unitOption: [],
      categoryOption: [],
      formatOption: [],
      limitOption: [
        { label: "2 Tahun", value: 2 },
        { label: "5 Tahun", value: 5 },
        { label: "10 Tahun", value: 10 },
        { label: "30 Tahun", value: 30 },
      ],
      statusOption: [
        { label: "Publish", value: "Y" },
        { label: "Unpublish", value: "N" },
      ],
      aboutOption:[],
      accept: false,
      unitOption: [],
      editorSetting: [
              [ {
                  label: this.$q.lang.editor.align,
                  icon: this.$q.iconSet.editor.align,
                  fixedLabel: true,
                  list: 'only-icons',
                  options: ['left', 'center', 'right', 'justify']
                },],
                [ {
                  label: 'Text',
                  fixedLabel: true,
                  list: 'only-icons',
                  options: ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript']
                },],
              ['hr', 'link'],
              ['undo', 'redo'],
              ['print', 'fullscreen'],],
      selectFile: '',
      theFile: {},
    };
  },
  mounted() {
    this.fetch();
    this.id = this.$route.params.id
    if (this.id) {
      this.getInfo();
    }

  },
  created() {
    this.newInfo.timeCreated = new Date().getFullYear();
  },
  methods: {
    chgFile(){
      if(this.$refs.file.files[0])
        this.selectFile = this.$refs.file.files[0].name
      else
        this.selectFile = ''
    },
    getInfo() {
      this.$http
        .get("/info_public_byid/" + this.id, {
          headers: { Authorization: "Bearer " + token}
        })
        .then((result) => {
          this.newInfo = result.data;
        });
    },
    fetch() {
      this.$http
        .get("/category_info", {
          headers: { Authorization: "Bearer " + token}
        })
        .then((result) => {
          for (var i = 0; i < result.data.length; i++) {
            this.categoryOption.push({
              label: result.data[i].name,
              value: result.data[i].id,
            });
          }
        });

      this.$http
        .get("/format_info", {
          headers: { Authorization: "Bearer " + token}
        })
        .then((result) => {
          for (var i = 0; i < result.data.length; i++) {
            this.formatOption.push({
              label: result.data[i].name,
              value: result.data[i].id,
            });
          }
        });
      this.$http.get("/work_unit", {
        headers: { Authorization: "Bearer " + token}
      })
      .then((result) => {
        for (var i = 0; i < result.data.length; i++) {
          this.unitOption.push({
            label: result.data[i].name,
            value: result.data[i].id,
          });
        }
      })
      this.$http.get("/list_about", {
        headers: { Authorization: "Bearer " + token}
      })
      .then((result) => {
        for (var i = 0; i < result.data.length; i++) {
          this.aboutOption.push({
            label: result.data[i].name,
            value: result.data[i].id,
          });
        }
      })
    },
    onSubmit() {
      this.$refs.unit.validate();
      this.$refs.title.validate(); //this.$refs.descr.validate();
      this.$refs.category.validate();
      this.$refs.format.validate();
      this.$refs.place.validate();
      this.$refs.time.validate();
      this.$refs.limit.validate(); //this.$refs.base.validate();
      this.$refs.status.validate();
      this.$refs.about.validate();
      this.newInfo.description = this.newInfo.description.replace(/"/g,'\'')
      this.newInfo.legalBase = this.newInfo.legalBase.replace(/"/g,'\'')
      if (
        this.$refs.unit.hasError ||
        this.$refs.title.hasError || // this.$refs.descr.hasError ||
        this.$refs.category.hasError ||
        this.$refs.format.hasError ||
        this.$refs.place.hasError ||
        this.$refs.time.hasError ||
        this.$refs.limit.hasError || // this.$refs.base.hasError ||
        this.$refs.status.hasError ||
        this.$refs.about.hasError
      ) {
        this.formHasError = true;
      } 
      // else if (
      //   !this.$refs.file.files[0] &&
      //   (this.newInfo.url || this.newInfo.url == "")
      // ) {
      //   this.$q.notify({
      //     color: "negative",
      //     message: "Anda belum upload pilih file atau isi url!",
      //   });
      // } 
      else {
        if (this.newInfo.id) {
          var data = {
            updatedBy: this.$store.state.currentAdmin.username,
            updatedDate: this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            m_work_unit_id: this.newInfo.m_work_unit_id,
            m_about_id: this.newInfo.m_about_id,
            name: this.newInfo.name,
            description: this.newInfo.description,
            m_information_category_id: this.newInfo.m_information_category_id,
            m_information_format_id: this.newInfo.m_information_format_id,
            placeCreated: this.newInfo.placeCreated,
            timeCreated: this.newInfo.timeCreated,
            storagePeriode: this.newInfo.storagePeriode,
            legalBase: this.newInfo.legalBase,
            active: this.newInfo.active,

          }
            // this.newInfo.updatedBy = this.$store.state.currentAdmin.username
            // this.newInfo.updatedDate = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
            this.$http
            .put(
              "/update_info_public/" + this.id,
              data, {
                headers: { Authorization: "Bearer " + token}
            })
            .then((result) => {
              this.upload(this.newInfo.id)
              });
        } else {
          this.newInfo.createdBy = this.$store.state.currentAdmin.username
          this.$http
            .post("/new_info_public/", this.newInfo, {
              headers: { Authorization: "Bearer " + token}
            })
            .then((result) => {
              this.upload(result.data)
            });
        }

      }
    },
    upload(id){
        this.theFile = this.$refs.file.files[0];
        if(this.theFile){
          var data = {file: this.theFile.name}
          var formData = new FormData();
          formData.append("file", this.theFile);
          formData.append("folder", "filedip/");
          this.$http
            .post("/upload.php", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((result) => {
              this.$http
                .put( "/update_info_public/" + id, data,{headers: { Authorization: "Bearer " + token}})
                .then((result) => {
                  
                });
            })
        }
        
        this.$router.push("/admin/dip");
        this.$q.notify({
          icon: "done",
          color: "positive",
          message: "Saved",
        });
    }
  },
};
